/**
 * Warn when the From display name and the email signature look like different people.
 * Empty signature is not a mismatch (the default sign-off uses the From name).
 */
export function signatureDisagreesWithFromName(fromName, signature) {
  const name = String(fromName || '').trim();
  const sig = String(signature || '').trim();
  if (!name || !sig) return false;
  const nameLower = name.toLowerCase();
  const sigLower = sig.toLowerCase();
  if (sigLower.includes(nameLower)) return false;
  const firstToken = name.split(/[\s,]/).find((t) => t.trim().length >= 3);
  if (firstToken && sigLower.includes(firstToken.toLowerCase())) return false;
  return true;
}

export const SIGNATURE_MISMATCH_COPY =
  'The From name and the email signature do not match. Recipients may treat that as a phishing tell — use the same person or team in both.';
